import { useState, useEffect } from 'react';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';

const API = process.env.REACT_APP_API_URL;

const MESI = ['Gennaio','Febbraio','Marzo','Aprile','Maggio','Giugno','Luglio','Agosto','Settembre','Ottobre','Novembre','Dicembre'];

export default function ReportMensile() {
  const { utente } = useAuth();
  const now = new Date();
  const [anno, setAnno] = useState(now.getFullYear());
  const [mese, setMese] = useState(now.getMonth() + 1);
  const [report, setReport] = useState(null);
  const [loading, setLoading] = useState(false);
  const [sedi, setSedi] = useState([]);
  const [reparti, setReparti] = useState([]);
  const [filtroSede, setFiltroSede] = useState('');
  const [filtroReparto, setFiltroReparto] = useState('');
  const [dettaglioAperto, setDettaglioAperto] = useState(null);

  useEffect(() => {
    axios.get(`${API}/sedi`).then(r => setSedi(r.data || [])).catch(() => {});
    axios.get(`${API}/reparti`).then(r => setReparti(r.data || [])).catch(() => {});
  }, []);

  useEffect(() => {
    carica();
  }, [anno, mese, filtroSede, filtroReparto]);

  const carica = async () => {
    setLoading(true);
    try {
      let url = `${API}/report-mensile?anno=${anno}&mese=${mese}`;
      if (filtroSede) url += `&sede_id=${filtroSede}`;
      if (filtroReparto) url += `&reparto_id=${filtroReparto}`;
      const res = await axios.get(url);
      setReport(res.data);
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  const repartiFiltrati = reparti.filter(r =>
    !filtroSede || r.field === filtroSede || r.Sede === filtroSede
  );

  const formatData = (iso) => {
    if (!iso) return '—';
    return new Date(iso).toLocaleTimeString('it-IT', { hour: '2-digit', minute: '2-digit' });
  };

  const formatGiorno = (str) => {
    const d = new Date(str);
    return d.toLocaleDateString('it-IT', { weekday: 'short', day: 'numeric', month: 'short' });
  };

  const esportaCSV = () => {
    if (!report) return;
    let csv = 'Cognome,Nome,Sede,Reparto,Giorni Lavorati,Ore Totali,Media Giornaliera\n';
    report.dipendenti.forEach(d => {
      csv += `${d.cognome},${d.nome},${d.sede},${d.reparto},${d.giorni_lavorati},${d.ore_totali},${d.media_giornaliera}\n`;
    });
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `presenze_${MESI[mese-1]}_${anno}.csv`;
    a.click();
  };

  return (
    <div style={{ padding: '24px 16px', paddingBottom: 90 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 6 }}>
        <h2 style={{ color: '#f1f5f9', fontSize: 22, fontWeight: 800, margin: 0 }}>Report Mensile</h2>
        <button onClick={esportaCSV}
          style={{ background: '#10b98118', border: '1px solid #10b98144', borderRadius: 10, padding: '8px 12px', color: '#10b981', fontWeight: 700, cursor: 'pointer', fontSize: 12 }}>
          📥 CSV
        </button>
      </div>
      <p style={{ color: '#64748b', fontSize: 14, marginBottom: 20 }}>Ore e giorni lavorati per dipendente</p>

      {/* Selezione mese/anno */}
      <div style={{ display: 'flex', gap: 8, marginBottom: 12 }}>
        <select value={mese} onChange={e => setMese(Number(e.target.value))}
          style={{ flex: 2, padding: '10px 12px', background: '#1e293b', border: '1px solid #334155', borderRadius: 10, color: '#f1f5f9', fontSize: 14, outline: 'none' }}>
          {MESI.map((m, i) => <option key={i+1} value={i+1}>{m}</option>)}
        </select>
        <select value={anno} onChange={e => setAnno(Number(e.target.value))}
          style={{ flex: 1, padding: '10px 12px', background: '#1e293b', border: '1px solid #334155', borderRadius: 10, color: '#f1f5f9', fontSize: 14, outline: 'none' }}>
          {[2024, 2025, 2026, 2027].map(a => <option key={a} value={a}>{a}</option>)}
        </select>
      </div>

      {/* Filtri */}
      <select value={filtroSede} onChange={e => { setFiltroSede(e.target.value); setFiltroReparto(''); }}
        style={{ width: '100%', padding: '10px 12px', background: '#1e293b', border: '1px solid #334155', borderRadius: 10, color: '#f1f5f9', fontSize: 14, marginBottom: 10, boxSizing: 'border-box', outline: 'none' }}>
        <option value="">Tutte le sedi</option>
        {sedi.map(s => <option key={s.id} value={s.id}>{s.Nome}</option>)}
      </select>

      <select value={filtroReparto} onChange={e => setFiltroReparto(e.target.value)}
        style={{ width: '100%', padding: '10px 12px', background: '#1e293b', border: '1px solid #334155', borderRadius: 10, color: '#f1f5f9', fontSize: 14, marginBottom: 20, boxSizing: 'border-box', outline: 'none' }}>
        <option value="">Tutti i reparti</option>
        {repartiFiltrati.map(r => <option key={r.id} value={r.id}>{r.Nome}</option>)}
      </select>

      {loading ? (
        <p style={{ color: '#475569', textAlign: 'center', padding: 30 }}>Caricamento...</p>
      ) : report ? (
        <>
          {/* Riepilogo mese */}
          <div style={{ background: '#1e293b', borderRadius: 14, padding: 16, marginBottom: 20, border: '1px solid #334155' }}>
            <p style={{ color: '#64748b', fontSize: 11, fontWeight: 700, letterSpacing: '0.08em', margin: '0 0 8px' }}>
              {MESI[mese-1].toUpperCase()} {anno} · {report.giorni_lavorativi} giorni
            </p>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <div>
                <p style={{ color: '#475569', fontSize: 11, margin: '0 0 2px' }}>Dipendenti</p>
                <p style={{ color: '#f1f5f9', fontSize: 22, fontWeight: 800, margin: 0 }}>{report.dipendenti.length}</p>
              </div>
              <div>
                <p style={{ color: '#475569', fontSize: 11, margin: '0 0 2px' }}>Con presenze</p>
                <p style={{ color: '#10b981', fontSize: 22, fontWeight: 800, margin: 0 }}>
                  {report.dipendenti.filter(d => d.giorni_lavorati > 0).length}
                </p>
              </div>
              <div>
                <p style={{ color: '#475569', fontSize: 11, margin: '0 0 2px' }}>Nessuna presenza</p>
                <p style={{ color: '#ef4444', fontSize: 22, fontWeight: 800, margin: 0 }}>
                  {report.dipendenti.filter(d => d.giorni_lavorati === 0).length}
                </p>
              </div>
            </div>
          </div>

          {/* Lista dipendenti */}
          {report.dipendenti.map(d => (
            <div key={d.id} style={{ background: '#1e293b', borderRadius: 12, marginBottom: 8, border: `1px solid ${d.giorni_lavorati > 0 ? '#334155' : '#ef444422'}`, overflow: 'hidden' }}>
              <div style={{ padding: '12px 14px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
                onClick={() => setDettaglioAperto(dettaglioAperto === d.id ? null : d.id)}>
                <div>
                  <p style={{ color: '#f1f5f9', fontSize: 14, fontWeight: 700, margin: '0 0 3px' }}>{d.cognome} {d.nome}</p>
                  <p style={{ color: '#475569', fontSize: 12, margin: 0 }}>{d.reparto} · {d.sede}</p>
                </div>
                <div style={{ textAlign: 'right' }}>
                  <p style={{ color: d.giorni_lavorati > 0 ? '#f59e0b' : '#ef4444', fontSize: 15, fontWeight: 800, margin: '0 0 2px' }}>
                    {d.ore_totali}
                  </p>
                  <p style={{ color: '#64748b', fontSize: 11, margin: 0 }}>
                    {d.giorni_lavorati}/{report.giorni_lavorativi} giorni
                  </p>
                </div>
              </div>

              {/* Dettaglio giorni */}
              {dettaglioAperto === d.id && d.dettaglio.length > 0 && (
                <div style={{ borderTop: '1px solid #0f172a', padding: '8px 14px' }}>
                  <p style={{ color: '#64748b', fontSize: 11, fontWeight: 700, margin: '0 0 8px', letterSpacing: '0.08em' }}>
                    MEDIA: {d.media_giornaliera}/giorno
                  </p>
                  {d.dettaglio.map(g => (
                    <div key={g.giorno} style={{ display: 'flex', justifyContent: 'space-between', padding: '5px 0', borderBottom: '1px solid #1e293b' }}>
                      <span style={{ color: '#94a3b8', fontSize: 12 }}>{formatGiorno(g.giorno)}</span>
                      <div style={{ textAlign: 'right' }}>
                        <span style={{ color: '#f1f5f9', fontSize: 12, fontWeight: 600 }}>{g.ore_lavorate}</span>
                        <span style={{ color: '#475569', fontSize: 11, marginLeft: 8 }}>
                          {formatData(g.ingresso)} → {formatData(g.uscita)}
                        </span>
                      </div>
                    </div>
                  ))}
                  {d.dettaglio.length === 0 && (
                    <p style={{ color: '#475569', fontSize: 12, textAlign: 'center', padding: 8 }}>Nessuna presenza questo mese</p>
                  )}
                </div>
              )}
            </div>
          ))}
        </>
      ) : null}
    </div>
  );
}
